"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.transmitProtoEvents = exports.transmitJsonEvents = void 0;
var json_1 = require("../logEvent/json");
var getUploadConfig_1 = require("./getUploadConfig");
var constants_1 = require("./constants");
var logger_1 = require("../logger");
var fetchRetry_1 = require("./fetchRetry");
var grapheneMetrics_1 = require("../grapheneMetrics");
var framedevent_1 = require("@snapchat/ts-protos/data/framedevent");
var debug_1 = require("../debug");
function transmitJsonEvents(events) {
    return __awaiter(this, void 0, void 0, function () {
        var jsonBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    jsonBody = (0, json_1.stringifyBlizzardJsonArray)(events);
                    return [4, upload(jsonBody, constants_1.CONTENT_TYPE_JSON, events.length)];
                case 1:
                    _a.sent();
                    (0, debug_1.logDebugAction)({ type: "EventsUploaded", events: events });
                    return [2];
            }
        });
    });
}
exports.transmitJsonEvents = transmitJsonEvents;
function transmitProtoEvents(frameStart, events) {
    return __awaiter(this, void 0, void 0, function () {
        var frameItem, eventItems, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (events.length === 0) {
                        return [2];
                    }
                    frameItem = { item: { frameStart: frameStart, $case: "frameStart" } };
                    eventItems = events.map(function (event) { return ({
                        item: {
                            event: event,
                            $case: "event"
                        }
                    }); });
                    body = framedevent_1.LoggedEventList.encode({
                        sequentialItems: __spreadArray([frameItem], __read(eventItems), false),
                        events: []
                    }).finish();
                    grapheneMetrics_1.blizzardGraphene.addHistogram({
                        metricsName: grapheneMetrics_1.UPLOAD_BODY_SIZE,
                        value: body.length
                    });
                    return [4, upload(body, constants_1.CONTENT_TYPE_PROTO, events.length)];
                case 1:
                    _a.sent();
                    (0, debug_1.logDebugAction)({ type: "EventsUploaded", events: events, frameStart: frameStart });
                    return [2];
            }
        });
    });
}
exports.transmitProtoEvents = transmitProtoEvents;
function upload(body, contentType, count) {
    return __awaiter(this, void 0, void 0, function () {
        var uploadConfig, success;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log.debug("Uploading ".concat(count, " event(s)... [").concat(contentType, "]"));
                    return [4, (0, getUploadConfig_1.tryToGetUploadConfig)()];
                case 1:
                    uploadConfig = _a.sent();
                    if (!uploadConfig) {
                        grapheneMetrics_1.blizzardGraphene.increment({ metricsName: grapheneMetrics_1.UPLOAD_FAIL_FROM_BAD_CONFIGS });
                        log.error("Failed to get upload config after several attempts. Discarding upload attempt.");
                        return [2];
                    }
                    return [4, (0, fetchRetry_1.fetchRetry)("".concat(uploadConfig.baseUrl, "/events"), function () { return ({
                            method: "POST",
                            headers: {
                                "Content-Type": contentType,
                                Authorization: uploadConfig.authorizationHeader,
                                "X-Blizzard-Upload-Timestamp": "".concat(new Date().getTime())
                            },
                            body: body,
                            credentials: uploadConfig.credentials,
                            keepalive: true,
                            onStatus: function (status) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!constants_1.STATUSES_POSSIBLE_AUTH_FAILURE.includes(status)) return [3, 2];
                                            log.info("Auth failure, attempting to refresh authentication...");
                                            return [4, (0, getUploadConfig_1.tryToGetUploadConfig)(uploadConfig)];
                                        case 1:
                                            uploadConfig = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : uploadConfig;
                                            _b.label = 2;
                                        case 2: return [2];
                                    }
                                });
                            }); }
                        }); })];
                case 2:
                    success = _a.sent();
                    if (success) {
                        log.debug("Uploaded ".concat(count, " event(s)"));
                    }
                    else {
                        log.error("Failed to upload events after retries, discarding upload attempt.");
                    }
                    return [2];
            }
        });
    });
}
var log = (0, logger_1.getLogger)("transmit");
//# sourceMappingURL=transmit.js.map